import type { TranslationsBase } from './ko';

const zhTW: TranslationsBase = {
  lang: 'zh-TW',
  langName: '繁體中文',
  flag: '🇹🇼',

  siteTitle: '托福模擬試題免費線上練習 — AI弱點分析 | Power TOEFL 2026',
  siteDescription: '2026最新托福線上模擬試題3,500+題免費練習。AI弱點分析、艾賓浩斯複習、分數換算表——台灣托福準備平台。',
  ogTitle: '托福模擬試題免費線上練習 — AI弱點分析 | Power TOEFL 2026',

  navGrammar: '文法',
  navPractice: '分Part練習',
  navScoreChart: '分數換算表',
  navVocabulary: '單字本',
  navTips: '技巧/策略',
  navFAQ: 'FAQ',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: '口說',
  navWriting: '寫作',
  navQuestionPool: '題庫',
  navResources: '學習資源',

  loginButton: '登入',
  wrongAnswers: '錯題筆記',
  logout: '登出',
  loginRequired: '錯題筆記及繼續作答需要登入。',
  googleLogin: '用Google開始並啟用進階功能',

  heroBadge: '頂級 TOEFL 備考系統',
  heroTitle1: '為托福高分打造的',
  heroTitle2: '唯一學習平台',
  heroDesc1: '從2026年制四大技能模考到錯題筆記，',
  heroDesc2: '助你高效達成目標分數。',

  lcTitle: 'Listening',
  lcSubtitle: 'Listening — 47題',
  lcTime: '29分鐘',
  rcTitle: 'Reading',
  rcSubtitle: 'Reading — 50題',
  rcTime: '30分鐘',
  startTest: '開始測驗',
  fullTestStart: '開始完整模擬考（Reading → Listening）',
  fullTestDesc: '依序完成兩個部分',

  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  moreTools: '更多學習工具',
  practiceLabel: '分Part練習',
  practiceDesc: 'Reading·Listening 個別學習',
  scoreChartLabel: '分數換算表',
  scoreChartDesc: '答對題數 → 換算分數',
  vocabLabel: '單字本',
  vocabDesc: '托福必備詞彙',
  tipsLabel: '技巧/策略',
  tipsDesc: 'Listening·Reading攻略法',
  catLabel: 'CAT測驗',
  catDesc: '根據實力自動調整難度',
  fullTestCardLabel: 'Full Test模擬考',
  fullTestCardDesc: 'Reading + Listening實戰模擬',

  statQuestions: '題',
  statParts: '個Part',
  statMinutes: '分鐘',

  footerMockTest: '練習',
  footerQuestionPool: '題庫',
  footerPractice: '分Section練習',
  footerStudy: '學習',
  footerBooks: '推薦教材',
  footerEtc: '其他',
  footerLC: 'Listening練習',
  footerRC: 'Reading練習',
  footerSpeaking: 'Speaking練習',
  footerWriting: 'Writing練習',
  footerLCStrategy: 'Listening策略',
  footerRCStrategy: 'RC策略',
  footerCopyright: '© 2026 Power TOEFL. All rights reserved.',
  footerDisclaimer: 'TOEFL®為ETS的註冊商標。Power TOEFL與ETS無關，為獨立運營的托福學習平台。',

  faqTitle: '❓ 常見問題 (FAQ)',
  faqDesc: '關於托福考試和Power TOEFL的常見問題。',
  faqPageTitle: '托福報名·分數計算·有效期限 — 2026 FAQ總整理 | Power TOEFL',
  faqPageDesc: '托福報名方法、分數換算、有效期限、分Part策略 — 30個最常見問題一頁看完。',
  faqMore: '還有其他問題嗎？我們持續更新FAQ。',

  scoreChartPageTitle: '托福分數換算表 2026 — 答對幾題是幾分？立即對照 | Power TOEFL',
  scoreChartPageDesc: '2026最新托福分數換算表。輸入LC·RC答對題數，立即算出預估分數。附目標分數學習指南，完全免費。',
  scoreChartHeading: '📊 托福分數換算表 2026',
  scoreChartIntro: '各科0–30與總分0–120表是Power TOEFL依舊制／可比較尺度提供的學習估值。2026官方成績單以各科及總分1–6分（每0.5分）為主。',
  scoreChartLC: 'LC（聽力）換算表',
  scoreChartRC: 'RC（閱讀）換算表',
  scoreChartCorrect: '答對題數',
  scoreChartConverted: '換算分數',
  scoreChartUnit: '題',
  scoreChartPointUnit: '分',
  scoreGuideTitle: '🎯 目標分數指南',
  scoreGuide900: '頂尖',
  scoreGuide900Desc: '需要LC 90+ / RC 90+答對。接近滿分水準。',
  scoreGuide800: '高階',
  scoreGuide800Desc: '目標LC 80+ / RC 80+答對。高級商務英文。',
  scoreGuide700: '中高階',
  scoreGuide700Desc: '滿足大部分求職條件。需要持續學習。',
  scoreGuide600: '中階',
  scoreGuide600Desc: '基礎已建立。建議專攻 Reading 和 Listening。',
  scoreChartFaqTitle: '❓ 托福分數常見問題',
  scoreChartCtaTitle: '立即確認您的實力',
  scoreChartCtaDesc: '透過免費2026年制模考了解您的預估分數。',

  vocabPageTitle: '托福必背單字600個 — 中文意思·例句·分類記憶 | Power TOEFL',
  vocabPageDesc: '托福高頻單字600個，分商務·人資·行銷·財務·製造·日常6大類。點擊看中文意思和例句，免費線上背單字。',
  vocabHeading: '📚 托福必背單字本',
  vocabIntro: '按主題分類學習托福必背單字。點擊即可查看中文意思和例句。',
  vocabShowAll: '全部顯示',
  vocabHideAll: '全部隱藏',
  vocabReset: '重置',
  vocabClickToReveal: '點擊查看含義',
  vocabMotivation: '持續反覆學習，托福分數一定會提升！🚀',
  vocabCatNaturalScience: '自然科學',
  vocabCatSocialScience: '社會科學',
  vocabCatHumanities: '人文學',
  vocabCatLifeScience: '生命科學',
  vocabCatTechnology: '技術/工程',
  vocabCatAcademicGeneral: '學術通用',
  vocabSynonyms: '同義詞',
  vocabAntonyms: '反義詞',
  vocabMyWords: '我的單字本',
  vocabAddWord: '新增單字',
  vocabAddWordPlaceholder: '輸入英文單字',
  vocabMyWordsEmpty: '還沒有單字，試著在上方新增吧！',
  vocabDeleteWord: '刪除',
  vocabLookingUp: '搜尋中...',
  vocabQuizTitle: '單字測驗',
  vocabQuizDesc: '測試你學過的同義詞和反義詞！',
  vocabQuizMode_synonym: '同義詞測驗',
  vocabQuizMode_antonym: '反義詞測驗',
  vocabQuizMode_mixed: '混合測驗',
  vocabQuizClose: '關閉',
  vocabQuizNoQuestions: '此分類題目不足。',
  vocabQuizBack: '返回',
  vocabQuizResult: '測驗結果',
  vocabQuizExcellent: '太棒了！🎉',
  vocabQuizGood: '做得好！再練習一下就完美了！',
  vocabQuizKeepGoing: '繼續加油！💪',
  vocabQuizRetry: '再試一次',
  vocabQuizFindSynonym: '請選出以下單字的同義詞',
  vocabQuizFindAntonym: '請選出以下單字的反義詞',
  vocabQuizNext: '下一題',
  vocabQuizFinish: '查看結果',
  vocabQuizStart: '開始測驗',

  tipsLCPageTitle: '托福聽力怎麼準備？LC提分攻略 Conversations·Lectures | Power TOEFL 2026',
  tipsLCPageDesc: '托福聽力LC怎麼拿高分？Conversations·Lectures各Part攻略法、預讀技巧、常見陷阱破解。2026最新實戰攻略。',
  tipsLCHeading: '🎧 托福聽力攻略——怎麼拿高分？',
  tipsLCIntro: '托福LC各Part的核心攻略和實戰訓練方法，用對策略分數就能明顯提升。',
  tipsLCButton: 'LC攻略',
  tipsRCButton: 'RC攻略',
  tipsLCPractice: 'LC實戰練習',
  tipsLCPracticeDesc: '學會攻略後立即用模擬題練習。',
  tipsLCStartTest: '開始LC練習',
  tipsRCPageTitle: '托福閱讀時間不夠怎麼辦？RC時間分配攻略 | Power TOEFL 2026',
  tipsRCPageDesc: '托福RC閱讀做不完？Reading時間分配策略、速讀技巧、雙篇三篇攻略。2026最新解法。',
  tipsRCHeading: '📖 托福閱讀攻略——時間不夠怎麼辦？',
  tipsRCIntro: '托福RC的時間分配策略和各Part攻略法，掌握節奏就不會做不完。',
  tipsRCPractice: 'RC實戰練習',
  tipsRCPracticeDesc: '學會攻略後立即用模擬題練習。',
  tipsRCStartTest: '開始RC練習',

  practicePartMeta: {
    '1': { title: 'TOEFL Reading 學術文章攻略 — 20題完整策略 | Power TOEFL', desc: 'TOEFL Reading 學術文章的高效閱讀法。關鍵字掃描、推論題、摘要題攻略一次整理。' },
    '2': { title: 'TOEFL Listening 校園對話攻略 — 筆記策略 | Power TOEFL', desc: 'TOEFL Listening Conversations 核心策略。掌握教授與學生對話的目的、態度推論、筆記技巧。' },
    '3': { title: 'TOEFL Listening 講座攻略 — 18題核心策略 | Power TOEFL', desc: 'TOEFL Listening Lectures 攻略法。掌握講座主題、教授意圖推論、舉例分析以達到高分。' },
  } as Record<string, { title: string; desc: string }>,

  practicePartContent: {
    '1': {
      intro: 'TOEFL Reading 部分需閱讀學術文章（約700字）並回答主題、細節、推論、詞彙和摘要問題。35分鐘內完成2篇文章共20題。掌握每段主題句和關鍵字掃描是時間管理的關鍵。',
      commonTypes: ['主題/目的 (What is the passage mainly about?)', '細節資訊 (According to the passage...)', '詞彙題 (The word X is closest in meaning to...)', '推論題 (What can be inferred?)', '句子插入 (Insert text)', '摘要題 (Prose Summary — 選擇核心3項)'],
      strategy: ['先讀問題記住2~3個關鍵字再掃描文章', '專注每段第一句（主題句）— TOEFL學術文章多為總分結構', '詞彙題依文脈判斷而非字典定義', '摘要題只選核心論點而非細節'],
      recommendedFor: ['TOEFL入門者 — 建立學術閱讀感覺', 'Reading 20分以上目標 — 時間分配策略必備', '推論·摘要題弱的學習者 — 題型集中訓練'],
      faq: [
        { q: 'TOEFL Reading時間不夠怎麼辦？', a: '每篇分配17~18分鐘，難題先標記跳過。摘要題至少預留3分鐘。' },
        { q: '詞彙題遇到不認識的字怎麼辦？', a: '從上下文推論意思。空格前後的句子就是線索，可能與字典定義不同。' },
        { q: '摘要題(Prose Summary)怎麼做？', a: '選擇代表每段核心論點的3個選項，只涉及單一段落細節的是錯誤答案。' },
      ],
    },
    '2': {
      intro: 'TOEFL Listening Conversations 聽校園對話（教授與學生、職員與學生），約3~5分鐘，回答5題。重點是掌握對話目的、細節和說話者態度。',
      commonTypes: ['對話目的 (Why does the student visit the professor?)', '細節資訊 (What does the professor say about...?)', '態度/意圖 (What is the student\'s attitude?)', '下一步行動 (What will the student probably do next?)'],
      strategy: ['對話開頭立即掌握來訪目的', '筆記記錄核心資訊（姓名、日期、條件）', '注意說話者語氣和情感表達 — 態度題的關鍵線索', '專注對話結尾的結論和後續行動'],
      recommendedFor: ['TOEFL Listening 15分以下 — 從短對話培養感覺', '想從比Lectures容易的題型開始的學習者', '需要練習筆記技巧的學習者'],
      faq: [
        { q: 'Conversations一定要做筆記嗎？', a: '是的。TOEFL在對話結束後才顯示問題，只靠記憶容易遺漏細節。善用縮寫和符號快速記錄是關鍵。' },
        { q: '如何判斷說話者的態度？', a: '語氣（確定/不確定）、情感表達("I\'m not sure about that", "That sounds great")、重複強調是態度題的核心線索。' },
      ],
    },
    '3': {
      intro: 'TOEFL Listening Lectures 聽大學講座（約5~7分鐘）回答6題。涵蓋生物學、歷史、藝術、地質學等各種學術主題。掌握講座主題、教授意圖推論和舉例分析是關鍵。',
      commonTypes: ['講座主題 (What is the lecture mainly about?)', '教授意圖 (Why does the professor mention X?)', '細節資訊 (According to the professor...)', '推論 (What does the professor imply?)', '講座結構 (How does the professor organize the lecture?)'],
      strategy: ['講座前1~2分鐘掌握主題和目的 — 最基本的題型', '隨時思考教授舉例的原因 — "Why does the professor mention X?"的核心', '轉換語(Now, let\'s move on to...)標示新子題開始', '推論教授的反語、幽默和修辭問句的含義'],
      recommendedFor: ['TOEFL Listening 20分以上目標 — Lectures是分數關鍵', '聽學術講座感到困難的學習者', '想建立筆記系統的學習者'],
      faq: [
        { q: '"Why does the professor mention X?"怎麼做？', a: '教授提到例子/比喻/實驗通常是為了補充或對比之前的概念。在提及前的上下文中找目的。' },
        { q: 'Lectures沒有背景知識會吃虧嗎？', a: '不會。TOEFL在講座中提供所有必要資訊。背景知識有幫助，但講座內容足以回答所有問題。' },
      ],
    },
  } as Record<string, { intro: string; commonTypes: string[]; strategy: string[]; recommendedFor: string[]; faq: { q: string; a: string }[] }>,

  practiceRelatedLinks: '📌 相關學習內容',
  practiceOtherParts: '其他Part攻略',
  practiceMockTestCTA: '用模擬考練習',
  practiceTipsLink: '查看Part策略',
  practiceGrammarLink: '學習文法',

  practiceNotFound: '找不到該Part。',
  practiceQuestionType: '題型',
  practiceTips: '💡 攻略技巧',
  practiceExamples: '📝 範例題',
  practiceIntro: '📋 Part介紹',
  practiceCommonTypes: '📊 常見題型',
  practiceStrategy: '🎯 攻略要點',
  practiceRecommendedFor: '👤 推薦對象',
  practiceFAQ: '❓ 常見問題',
  practiceCTA: '立即開始練習',
  practiceCTADesc: '在和實際考試相同的環境中練習Part {0}。',
  practiceStartTest: '開始{0}模擬考',
  practiceQuestions: '題',
  practicePartSelect: '選擇Part',

  roundsTitle: '模擬考回次',
  roundLabel: 'TOEFL模擬考',
  roundUnit: '回',
  comingSoon: '即將推出',

  testPrevious: '上一題',
  testNext: '下一題',
  testQuestion: '題目',
  testQuestionPrompt: '請看題目選出正確答案。',
  testMarkAnswer: '請選擇正確的答案。',
  testSelect: '選擇',
  testShowAnswer: '查看答案與解析',
  testCorrect: '答對了！',
  testIncorrect: '答錯了。',
  testLoginPrompt: '錯題筆記及繼續作答需要登入。',
  testGoogleLogin: '用Google 3秒開始',
  roundSelect: '選擇其他回次',
  testAnswered: '已作答',
  testSubmit: '提交測驗',
  testSubmitTitle: '要提交{0}測驗嗎？',
  testSubmitDesc: '{0}題中已回答{1}題。',
  testUnanswered: '{0}題未作答。',
  testCannotUndo: '此操作無法取消。',
  testContinue: '繼續作答',
  testSubmitBtn: '提交',

  resultsTitle: '{0}測驗結果',
  resultsTimeUsed: '用時：{0}分{1}秒',
  resultsEstimatedScore: '預估分數（滿分30）',
  resultsCorrect: '答對',
  resultsIncorrect: '答錯',
  resultsAccuracy: '正確率',
  resultsReview: '檢視答案',
  resultsYourAnswer: '我的答案：{0}',
  resultsCorrectAnswer: '正確答案：{0}',
  resultsNoAnswer: '未作答',
  resultsHome: '首頁',
  resultsWrongNotes: '錯題筆記',
  resultsRetry: '重新測驗',
  resultsShare: '分享結果',
  resultsShareText: '我的TOEFL {0}預估分數是{1}分！（{2}/{3}答對，正確率{4}%）在Power TOEFL免費測試你的實力！',
  resultsShareCopied: '結果已複製到剪貼簿！',
  resultsNoResults: '沒有測驗結果。',
  resultsGoHome: '回首頁',
  resultsSaved: '{0}題錯題已存到錯題筆記',

  wrongAnswersTitle: '錯題筆記',
  wrongAnswersSaved: '已儲存題目',
  wrongAnswersHome: '首頁',
  wrongAnswersPracticeAll: '全部練習',
  wrongAnswersAll: '全部',
  wrongAnswersNoItems: '還沒有錯題。先參加測驗吧！',
  wrongAnswersYourAnswer: '我的答案：{0}',
  wrongAnswersCorrectIs: '正確答案：{0}',
  wrongAnswersReviewed: '已複習',
  wrongAnswersRemoved: '已從錯題筆記刪除',
  wrongAnswersPracticeMode: '練習模式',
  wrongAnswersCorrectMsg: '答對了！',
  wrongAnswersIncorrectMsg: '答錯了。正確答案：{0}',
  wrongAnswersNextQuestion: '下一題',
  wrongAnswersFinish: '完成',
  wrongAnswersExitPractice: '離開練習',
  wrongAnswersPracticeComplete: '練習完成！',
  wrongAnswersNoPractice: '沒有可練習的錯題',
  wrongAnswersLimitNotice: '僅顯示最近500筆錯題。',

  privacyPageTitle: '隱私權政策 — Power TOEFL',
  privacyPageDesc: 'Power TOEFL隱私權政策。',
  privacyHeading: '隱私權政策',
  privacyLastUpdated: '最後更新：2026年3月29日',
  privacyS1Title: '1. 收集的個人資訊',
  privacyS1Body: 'Power TOEFL在Google登入時收集電子郵件、姓名、個人照片。付款資訊透過Dodo Payments/PayPal處理。',
  privacyS2Title: '2. 使用目的',
  privacyS2Body: '收集的資訊用於錯題筆記、學習進度管理、訂閱管理和服務改善。',
  privacyS3Title: '3. 保存與刪除',
  privacyS3Body: '帳號註銷時資訊將立即刪除。付款記錄依稅法保留最多5年。',
  privacyS4Title: '4. 第三方提供',
  privacyS4Body: '僅為付款處理向Dodo Payments/PayPal提供電子郵件。',
  privacyS5Title: '5. Cookie與廣告',
  privacyS5Body: '本站使用Google AdSense及相關Cookie。可在瀏覽器設定中管理Cookie。',
  privacyS6Title: '6. 國際資料傳輸',
  privacyS6Body: '資料可能透過海外伺服器進行國際傳輸，並採取適當安全措施。',
  privacyS7Title: '7. 使用者權利',
  privacyS7Body: '使用者可隨時要求存取、更正或刪除個人資訊。',
  privacyS8Title: '8. 聯繫方式',
  privacyS8Body: '聯繫：skdaks0731@gmail.com',

  termsPageTitle: '服務條款 — Power TOEFL',
  termsPageDesc: 'Power TOEFL服務條款。',
  termsHeading: '服務條款',
  termsLastUpdated: '最後更新：2026年3月29日',
  termsS1Title: '1. 服務概述',
  termsS1Body: 'Power TOEFL是提供免費和付費（Pro/Lifetime）托福考試準備的線上學習平台，由 ddookddak（我們註冊的合法企業名稱）營運。',
  termsS2Title: '2. 使用條件',
  termsS2Body: '年滿14歲即可使用。部分功能需要Google帳號登入。',
  termsS3Title: '3. 智慧財產權',
  termsS3Body: '網站內容（題目、設計、程式碼）歸Power TOEFL所有。TOEFL為ETS的註冊商標。',
  termsS4Title: '4. 付款',
  termsS4Body: '付費訂閱透過Dodo Payments/PayPal處理。價格可能包含增值稅。',
  termsS5Title: '5. 免責聲明',
  termsS5Body: '模擬考分數為估算值，不保證實際TOEFL考試結果。',
  termsS6Title: '6. 禁止行為',
  termsS6Body: '禁止複製/散佈題目、對系統造成過度負擔、與他人共享帳號。',
  termsS7Title: '7. 服務變更',
  termsS7Body: '服務可能在不事先通知的情況下變更或停止。',
  termsS8Title: '8. 取消訂閱',
  termsS8Body: '訂閱可隨時取消。取消後可繼續使用至付費期間結束。',
  termsS9Title: '9. 條款變更',
  termsS9Body: '條款可能變更並在網站公告。繼續使用視為同意變更後的條款。',

  refundPageTitle: '退款政策 — Power TOEFL',
  refundPageDesc: 'Power TOEFL付費訂閱退款政策。',
  refundHeading: '退款政策',
  refundLastUpdated: '最後更新：2026年4月15日',
  refundS1Title: '1. 退款原則',
  refundS1Body: '由於數位商品特性，原則上不提供退款。',
  refundS2Title: '2. 例外退款情況',
  refundS2Body: '但在法律要求、重複扣款、服務未提供或重大技術故障等情況下，可能會例外提供退款。',
  refundS3Title: '3. 聯絡方式',
  refundS3Body: '如有退款相關問題，請使用支援/意見回饋渠道聯絡。聯絡方式：skdaks0731@gmail.com',
  refundS4Title: '4. 訂閱取消',
  refundS4Body: '付費訂閱可隨時取消。取消後仍可使用至當前計費週期結束，之後不再產生額外扣款。',
  refundS5Title: '',
  refundS5Body: '',
  refundS6Title: '',
  refundS6Body: '',

  footerPrivacy: '隱私權',
  footerTerms: '服務條款',
  footerRefund: '退款政策',
  footerAbout: '關於我們',
  footerGuide: '學習指南',
  guideLabel: '學習指南',
  guideDesc: '技巧攻略、分數策略、考試比較資訊',

  aboutPageTitle: '托福線上模考免費 + AI弱點分析 — 認識Power TOEFL',
  aboutPageDesc: '2026年制四大技能模考、AI弱點分析、錯題自動複習全部免費。',
  aboutHeading: 'Power TOEFL — 托福實戰模擬學習平台',
  aboutS1Title: '什麼是Power TOEFL？',
  aboutS1Body: 'Power TOEFL是免費的托福線上學習平台，提供2026年制四大技能模考、AI出題和錯題筆記。',
  aboutS2Title: '適合哪些人？',
  aboutS2Body: '正在準備托福的大學生、需要達到目標分數的上班族、準備海外就業或轉職者，以及所有自學托福的人。',
  aboutS3Title: '主要功能',
  aboutFeature1: 'Reading·Listening·Speaking·Writing 2026年制模考（多回可選）',
  aboutFeature2: 'Reading·Listening·Speaking·Writing練習',
  aboutFeature3: 'AI依難度出題 & 弱點分析',
  aboutFeature4: '錯題自動儲存 + 遺忘曲線複習',
  aboutFeature5: '分數換算表及托福必背單字本',
  aboutS4Title: '免費版 vs 進階版',
  aboutS4Body: '免費：模擬考、分Part練習、分數換算表。進階(Pro)：AI無限出題、無廣告、全部回次。',
  aboutS5Title: '為什麼有效？',
  aboutS5Body: '遺忘曲線智慧複習、AI分析各部分弱點、2026年制模考環境培養考試感覺。',
  aboutS6Title: '與ETS的關係',
  aboutS6Body: 'Power TOEFL與ETS無關聯。TOEFL®為ETS的註冊商標。',
  aboutS7Title: '聯繫方式',
  aboutS7Body: '聯繫：skdaks0731@gmail.com',
  aboutCtaHeading: '立即開始',
  aboutCtaDesc: '免費試做實戰模擬考。',
  aboutCtaStart: '開始模考',
  aboutCtaPricing: '查看Premium方案',

  resumeTest: '繼續作答',
  resumeDesc: '{0} 第{1}回 — {2}/{3}題',
  progressLabel: '進度',
  timerLabel: '剩餘時間',
  timeUp: '時間到！',

  navHome: '首頁',
  navSettings: '技巧',

  grammarSectionTitle: '文法書',
  grammarSectionDesc: '系統化學習托福必考文法',
  grammarViewAll: '查看全部',
  grammarChapter: '章節',

  aiPracticeTitle: 'AI托福題目無限生成 — 選Part·難度立即出題 | Power TOEFL',
  aiPracticeDesc: '選擇Part和難度，AI立即生成托福題目。每天練習新題目。',
  aiPracticeH1: '✨ AI托福出題',
  aiPracticeSub: 'AI根據你的程度即時生成托福題目。',
  aiPartLabel: 'Part',
  aiDiffLabel: '難度',
  aiBeginner: '初級（1.0–2.5）',
  aiIntermediate: '中級（3.0–4.5）',
  aiAdvanced: '高級（5.0–6.0）',
  aiGenerate: '生成題目',
  aiGenerating: '生成中...',
  aiRemainingToday: '本月剩餘{0}次',
  aiLimitReached: '本月AI額度已用完',
  aiLimitUpgrade: '加購額度或升級方案！',
  aiUpgrade: '升級',
  aiListenPrompt: '🔊 LC題目請邊聽邊作答',
  aiPlayAudio: '播放音訊',
  aiStopAudio: '停止',
  aiCorrect: '✅ 答對了！',
  aiWrong: '❌ 答錯了。',
  aiCorrectAnswer: '正確答案：{0}',
  aiPrev: '上一題',
  aiNext: '下一題',
  aiNewQuestions: '新題目',
  aiEmptyTitle: '用AI生成題目',
  aiEmptyDesc: '選擇Part和難度後點擊「生成題目」。',
  aiLoadingMain: 'AI正在生成和驗證題目...',
  aiLoadingSub: '約需10~20秒',

  statsTitle: '托福學習統計 — Power TOEFL',
  statsDesc: '文法測驗正確率、錯題筆記複習狀態一覽。',
  statsH1: '📊 學習統計',
  statsLoginPrompt: '登入後可查看學習統計。',
  statsTotalQuizzes: '總測驗數',
  statsTotalQuestions: '總題數',
  statsAccuracy: '正確率',
  statsLast7Days: '最近7天',
  statsWrongSummary: '錯題筆記狀態',
  statsViewAll: '查看錯題筆記',
  statsTotalWrong: '總錯題',
  statsReviewed: '已複習',
  statsPending: '未複習',
  statsTopicAccuracy: '文法主題正確率',
  statsAttempts: '{0}次',
  statsEmpty: '尚無學習記錄。試試文法測驗！',
  statsStartGrammar: '開始文法學習',

  pricingTitle: '免費不夠用？ — Power TOEFL Pro（月付NT$499）| 托福備考效率翻倍',
  pricingDesc: '免費版每日練習 vs Pro版AI無限出題·無廣告·全回次。',

  testLCTitle: '托福Reading模考免費 — 學術文章閱讀 | 2026',
  testLCDesc: '2026年托福Reading模考免費練習。學術文章，錯題自動保存。',
  testRCTitle: '托福Listening模考免費 — 對話·講座聽力 | 2026',
  testRCDesc: '2026年托福Listening模考免費練習。對話與講座，附AI解析。',

  reviewTitle: '今日複習',
  reviewDesc: '基於遺忘曲線的智慧複習系統',
  reviewSubtitle: '在最佳時機根據遺忘曲線複習',
  reviewRemaining: '剩餘複習',
  reviewProgress: '複習進度',
  reviewCompleted: '🎉 今日複習完成！',
  reviewCompletedDesc: '已複習{0}題',
  reviewEmpty: '今天沒有需要複習的題目',
  reviewEmptyDesc: '全部複習完成或尚無錯題。',
  reviewStage: '第{0}階段',
  reviewNextInterval: '{0}天間隔',
  reviewCorrect: '答對！進入下一階段。',
  reviewWrong: '答錯。回到第1階段。',
  reviewNextReview: '下次複習：{0}天後',
  reviewResetMsg: '答錯，1天後再次複習。',
  reviewNext: '下一題',
  reviewFinish: '完成',
  reviewHowItWorks: '遺忘曲線複習原理',
  reviewDaysLater: '{0}天後',
  reviewExplanation: '錯題以1→3→7→14→30→60天間隔複習。答對進入下一階段，答錯回到第1階段。',

  notifTitle: '通知',
  notifEmpty: '沒有新通知',
  notifMarkAllRead: '全部已讀',
  timeJustNow: '剛剛',
  timeMinutes: '{0}分鐘前',
  timeHours: '{0}小時前',
  timeDays: '{0}天前',
  scoreCardEstimated: '預估分數',
  scoreCardCorrect: '正確',
  scoreCardIncorrect: '錯誤',
  scoreCardAccuracy: '正確率',

  pushTitle: '開啟學習提醒',
  pushDesc: '接收複習時間、連續學習記錄等通知。',
  pushEnable: '開啟',

  navReview: '複習',
  navStats: '統計',
  navPremium: '高級版',
  navSubscription: '訂閱管理',
  roundDetailHeading: 'TOEFL實戰模擬考',
  roundDetailOtherRounds: '查看其他回次',
  roundSuffix: '回',

  footer7DayPlan: '7天讀書法',
  footerTrapPatterns: '陷阱模式',

  pwaAddToHome: '📱 加到主畫面',
  pwaAddToHomeDesc: '像App一樣啟動！離線也能學習',
  pwaInstall: '安裝',
  pwaIOSGuide: '分享 → 加入主畫面',

  aiQuizTitle: '🤖 AI客製化練習題',
  aiQuizDesc: 'AI生成的TOEFL Grammar題目',
  aiQuizGenerateDesc: 'AI根據文法主題即時生成5題TOEFL Grammar風格題目。',
  aiQuizGenerate: '生成AI題目',
  aiQuizGenerating: '🤖 AI正在生成題目...',
  aiQuizGeneratingTime: '約需5~10秒',
  aiQuizNew: '新題目',
  aiQuizStats: '累計統計：',
  aiQuizTimes: '次',
  aiQuizCheckAnswers: '確認答案',
  aiQuizPerfect: '🎉 全部答對！',
  aiQuizCorrectCount: '答對',
  aiQuizSaving: '儲存結果中...',
  aiQuizTryNew: '試新題目',
  aiQuizError: 'AI題目生成失敗。請重試。',

  tipsDetailStrategy: '詳細策略',
  tips7DayTitle: '🗓️ 考前7天讀書法',
  tips7DayDesc: '用最後衝刺提升分數',
  tipsTrapTitle: '⚠️ 陷阱答案模式總整理',
  tipsTrapDesc: '提前識破5大常見陷阱',

  pricingSaveBadge: '省30%',
  pricingPerMonth: '月',
  pricingSSL: '安全付款',
  pricingCurrentPlan: '目前方案',
  pricingFaqQ1: '免費和 Pro 有什麼不同？',
  pricingFaqA1: '免費方案包含 Reading·Listening 基本題目和每日1次 AI 練習。Pro 包含無限 AI 模擬考、Speaking·Writing AI 批改、4技能弱點分析和去廣告。',
  pricingFaqQ2: '可以退款嗎？',
  pricingFaqA2: '由於數位商品特性，原則上不提供退款。但在法律要求、重複扣款、服務未提供或重大技術故障等情況下，可能會例外提供退款。',
  pricingFaqQ3: '如何取消訂閱？',
  pricingFaqA3: '您可以隨時在「我的訂閱」頁面取消。取消後仍可使用至到期日。',
  pricingFaqQ4: 'Lifetime 和 Pro 年繳有什麼不同？',
  pricingFaqA4: 'Lifetime 一次付款永久使用。Pro 年繳每年需要續約。',
  proBadgeLabel: 'Pro',
  pricingCard: '信用卡',
  pricingPaymentSuccess: '進階會員啟用成功！',
  pricingPaymentCancelled: '付款已取消。',
  pricingLoginRequired: '需要登入。',
  pricingPaymentError: '付款建立失敗。',

  subLoginRequired: '需要登入。',

  grammarSystematic: '系統化文法學習',
  grammarBookTitle: '托福文法書',
  grammarBookDesc: '系統化學習20個托福必考文法主題。每章含實戰例句和練習題，學完立即測驗。',
  grammarTestAfter: '學完文法立刻測驗！',
  grammarTestAfterDesc: '看看學到的文法在托福考試中怎麼出題',
  grammarMockTest: '模擬考',
  grammarDoneTitle: '文法學完了嗎？',
  grammarDoneDesc: '在模擬考中實際運用吧！錯題會自動儲存！',
  grammarStartRC: '開始RC模擬',
  grammarPracticePart5: 'Grammar練習',
  grammarCourseName: '托福英文法完整整理',
  grammarBreadcrumb: '文法書',

  grammarHome: '首頁',
  grammarExamples: '實戰例句',
  grammarTestKnowledge: '📝 實力測驗',
  grammarTestKnowledgeDesc: '練習剛學過的文法相關實戰題！',
  grammarCheckAnswers: '確認答案',
  grammarPerfect: '🎉 全部答對！',
  grammarCorrectCount: '答對',
  grammarMockCTA: '🔥 用模擬考驗證實力！',
  grammarMockCTADesc: 'RC 100題模擬考 + 錯題筆記自動生成',
  grammarStartRCMock: '開始RC模擬考',
  grammarPractice5: 'Grammar練習',
  grammarTestInPractice: '在實戰中確認！',
  grammarTestInPracticeDesc: '看看文法要點在TOEFL中怎麼出題。',
  grammarRelated: '📚 推薦一起看的文法',

  wrongAnswersGrammarAI: '文法AI',

  streakDays: '天',
  streakLabel: '連續學習',
  streak7: '連續學習1週！',
  streak14: '連續2週達成！',
  streak30: '太厲害了！連續1個月！',
  reviewItems: '題',
  reviewTodayLabel: '今日需複習題目',
  reviewGoLabel: '📚 去複習 →',

  leaderboardTitle: '學習排名',
  leaderboardWeekly: '週排名',
  leaderboardMonthly: '月排名',
  leaderboardLoading: '載入中...',
  loadingQuestions: '載入題目中...',
  leaderboardEmpty: '本{period}尚無資料',
  leaderboardEmptyWeek: '週',
  leaderboardEmptyMonth: '月',
  leaderboardHint: '完成測驗自動登入排名！',
  leaderboardRank: '排名',
  leaderboardNickname: '暱稱',
  leaderboardSolved: '題數',
  leaderboardAccuracy: '正確率',
  leaderboardMe: '我',
  leaderboardMyRank: '🏅 我的排名：第{rank}名',

  tipsCoreTips: '核心攻略',
  tipsStrategy: '實戰策略',
  tipsCTA: '學會策略了嗎？開始實戰！',

  testScrollHint: '捲動查看題目和選項',
  testPart1Label: 'Academic Reading',
  testPart2Title: 'Conversations',
  testPart2Desc: '聽音訊選擇答案',
  testPart3Label: 'Lectures',

  creditBuyBtn: '購買點數',
  creditBuyTitle: '購買 AI 點數',
  creditBuyDesc: '購買額外點數用於 Speaking/Writing AI 回饋和 AI 練習。',
  creditBuyError: '無法開始付款',
  creditBuyNote: '透過 PayPal 付款。付款完成後立即新增點數。',
  creditUnit: '點數',

  speakingPageH1: 'TOEFL Speaking 練習 2026',
  speakingPageSub: '{count}+ 免費 Speaking — Listen and Repeat · Interview',
  speakingPageTitle: 'TOEFL Speaking 練習 2026 — {count}+ 免費題目 | Power TOEFL',
  speakingPageDesc: 'TOEFL Speaking 練習題 {count}+ 題。範例答案、評分標準、AI回饋。2026最新。',
  speakingAllTasks: '全部',
  speakingNoPrompts: '尚無 Speaking 題目',
  speakingNoPromptsSub: '題目正在生成中，請稍後再查看！',
  speakingResponseTime: '作答時間',

  writingPageH1: 'TOEFL Writing 練習 2026',
  writingPageSub: '{count}+ 免費 Writing — Build a Sentence · Email · Academic Discussion',
  writingPageTitle: 'TOEFL Writing 練習 2026 — {count}+ 免費題目 | Power TOEFL',
  writingPageDesc: 'TOEFL Writing 練習 {count}+ 題。範例答案、評分標準。2026最新。',
  writingAllTasks: '全部',
  writingNoPrompts: '尚無 Writing 題目',
  writingNoPromptsSub: '題目正在生成中，請稍後再查看！',

  catPageTitle: 'TOEFL 適性測驗 (CAT) — AI 自動調整難度 | Power TOEFL',
  catPageDesc: 'TOEFL 電腦適性練習測驗。AI 根據正確率自動調整難度。',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: '根據正確率自動調整難度。每次 {count} 題。',
  catNote: "ℹ️ 注意：真實的 TOEFL iBT 是線性（非自適應）考試。此 Practice CAT 是一款根據你的表現調整難度、幫助你快速了解自身程度的學習工具，並非真實考試形式的模擬。",
  catSelectSection: '選擇科目',
  catStartBtn: '開始 Adaptive Test',
  catLoading: '載入下一題中...',
  catNoMore: '沒有更多題目了',
  catComplete: 'Adaptive Test 完成',
  catAccuracy: '正確率',
  catFinalLevel: '最終難度',
  catTryAgain: '再試一次',
  catViewResults: '查看結果',
  catNext: '下一題',
  catExplanation: '解析',
  catStop: '停止',
  catPlayAudio: '🔊 播放音頻',
  catReadingPassage: 'Reading Passage',

  scoreReadingHeader: 'Reading (0~30分)',
  scoreListeningHeader: 'Listening (0~30分)',
  scoreSpeakingHeader: 'Speaking (0~30分)',
  scoreWritingHeader: 'Writing (0~30分)',
  scoreSpeakingDesc: '4項任務以0~4分評分後換算為30分',
  scoreWritingDesc: '2項任務以0~5分評分後換算為30分',
  scoreSpeakingLevels: [
    ['4分 (Good)', '27~30分', '流暢準確的回答，邏輯清晰'],
    ['3分 (Fair)', '19~26分', '大致清楚但有部分錯誤'],
    ['2分 (Limited)', '11~18分', '基本溝通但受限'],
    ['1分 (Weak)', '1~10分', '難以傳達意義'],
  ] as [string, string, string][],
  scoreWritingLevels: [
    ['5分 (Good)', '27~30分', '邏輯清晰具體的文章，文法正確'],
    ['4分 (Fair)', '22~26分', '整體不錯但有不足'],
    ['3分 (Limited)', '15~21分', '有基本結構但展開不足'],
    ['2分 (Weak)', '8~14分', '偏離主題或結構不清'],
    ['1分 (Very Weak)', '1~7分', '幾乎無法傳達意義'],
  ] as [string, string, string][],
  scoreGuideDescs: [
    '需要 Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+。可申請頂尖大學。',
    '目標 Reading 22+ / Listening 22+。符合大多數大學入學標準。',
    '基礎學術英語程度。可條件式入學。需要集中學習。',
    '基礎階段。建議集中 Reading 和 Listening。',
  ],
  // --- Flashcard mode ---
  vocabFlashcardStart: "開始閃卡記憶",
  vocabFlashcardStop: "停止閃卡",
  vocabFlashcardEmpty: "請先新增單字再開始閃卡。",
  vocabFlashcardSpeed: "速度",
  vocabFlashcardSpeedSlow: "慢速",
  vocabFlashcardSpeedNormal: "正常",
  vocabFlashcardSpeedFast: "快速",
  vocabFlashcardShuffle: "打亂",
  vocabFlashcardPrev: "上一個",
  vocabFlashcardNext: "下一個",
  vocabFlashcardFlip: "翻面",
  vocabFlashcardProgress: "{current} / {total}",
};

export default zhTW;
